<template>
  <div class="mx-2 d-flex">
    <v-spacer />

    <sys-grupo-autocomplete
      v-model="filtros.grupo"
      label="Filtro de grupos"
      outlined
      dense
      :ocultar_grupos_todos="false"
      apenas_grupos_drp
      hide-details
      height="10"
      style="width: 125px"
    ></sys-grupo-autocomplete>

    <sys-filial-grupo-autocomplete
      v-model="filtros.filial"
      label="Filtro de Filiais"
      outlined
      dense
      multiple
      :idGrupo="filtros.grupo"
      class="ml-4"
      hide-details
      :disabled="disabled"
      :qtde-visivel-selecionados="5"
      height="10"
      style="width: 150px"
    ></sys-filial-grupo-autocomplete>

    <sys-segmentos-autocomplete
      v-model="filtros.segmentos"
      label="Filtro de Segmentos"
      outlined
      dense
      multiple
      :idGrupo="filtros.grupo"
      class="ml-4"
      hide-details
      :disabled="disabled"
      :qtde-visivel-selecionados="1"
      height="10"
      style="width: 180px"
    ></sys-segmentos-autocomplete>

    <sys-fornecedor-autocomplete
      v-model="filtros.fornecedores"
      label="Filtro de Fornecedores"
      outlined
      dense
      multiple
      :idGrupo="filtros.grupo"
      :qtde-visivel-selecionados="1"
      class="ml-4"
      hide-details
      :disabled="disabled"
      height="10"
      style="width: 180px"
    ></sys-fornecedor-autocomplete>

    <FiltrosUniversalAvancado
      content-class="ml-4"
      ocultar_filtros_fixos
      ocultar_filtro_combinados
      @limpar:filtros="limparFiltrosFilial()"
      @update:filtros="$emit('update:modelValue', {...filtros})"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          color="#1976D2"
          dark
          class="ml-4"
          :size="3"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="#FFFFFF" size="18">mdi-filter</v-icon>
          <span class="ml-1">Filtrar Escopo</span>
        </v-btn>
      </template>
    </FiltrosUniversalAvancado>

    <v-btn class="primary ml-4" :disabled="disabled" @click="$emit('update:modelValue', {...filtros})">
      <v-icon left>mdi-autorenew</v-icon>
      buscar
    </v-btn>
  </div>
</template>

<script>
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysSegmentosAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import DrpAPI from "@/api/drp";
import { logout } from "@/helpers";
import FiltrosUniversalAvancado from "@/components/utils/FiltrosUniversalAvancado.vue";
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";

export default {
  name: "BarraDeFiltro",
  components: {
    DivisorComLegenda,
    FiltrosUniversalAvancado,
    SysGrupoAutocomplete,
    SysFilialGrupoAutocomplete,
    SysSegmentosAutocomplete,
    SysFornecedorAutocomplete
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    filtros: {
      grupo: 0,
      filial: [],
      segmentos: [],
      fornecedores: [],
      filtro_filias: {
        filiais_origem: [],
        filiais_destino: []
      }
    }
  }),
  computed: {
    disabled() {
      return [null, undefined, 0].includes(this.filtros.grupo)
    }
  },
  created() {
    this.buscarGrupos();
  },
  methods: {
    buscarGrupos() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getGruposDrp(headers, { ativar_drp: 'S' })
        .then((response) => {
          const { token, grupos } = response.data;
          localStorage.setItem("token", token);

          if (grupos.length > 0) {
            this.filtros.grupo = grupos[0].id;
          }
        })
        .catch(logout)
      );
    },
    limparFiltrosFilial() {
      this.filtros.filtro_filias.filiais_origem = [];
      this.filtros.filtro_filias.filiais_destino = [];
    }
  }
}
</script>

<style scoped>
</style>
